import { CandidateLayout } from "@/components/candidate/CandidateLayout";
import { usePageMeta } from "@/hooks/usePageMeta";
import { useIsAdmin } from "@/hooks/useUserRole";
import { JobDigestPanel } from "@/components/admin/email/JobDigestPanel";
import { Mail } from "lucide-react";
import { Navigate } from "react-router-dom";

export default function JobDigest() {
  usePageMeta({
    title: "Digest de Vagas - Data Hire Club",
    description: "Controle e histórico dos emails de digest de vagas",
    noindex: true,
  });

  const { isAdmin, isLoading } = useIsAdmin();

  if (isLoading) {
    return (
      <CandidateLayout maxWidth="6xl">
        <p className="text-muted-foreground">Carregando...</p>
      </CandidateLayout>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/candidate/dashboard" replace />;
  }

  return (
    <CandidateLayout maxWidth="6xl">
      <div className="space-y-6">
        <div className="flex items-center gap-3">
          <Mail className="h-7 w-7 text-primary" />
          <div>
            <h1 className="text-2xl font-bold text-foreground">Emails / Digest de Vagas</h1>
            <p className="text-sm text-muted-foreground">
              Envie o compilado de vagas para a base e acompanhe o histórico de disparos
            </p>
          </div>
        </div>

        <JobDigestPanel />
      </div>
    </CandidateLayout>
  );
}
